import { GeoJSON, Map as LeafletMap } from 'leaflet';
import type { GeoJSONOptions } from 'leaflet';
import type { GeometryObject } from 'geojson';
import type { MapDataFeature } from '../data/mapDataType';

export type GeoJSONOptionsFixed = GeoJSONOptions<
  MapDataFeature['properties'],
  GeometryObject
> & {
  // Das styleName-Attribut ist vorhanden, fehlt aber irgendwie in der GeoJSON-Typ-Definition
  styleName?: string;
};
export type GeoJSONFixed = GeoJSON<
  MapDataFeature['properties'],
  GeometryObject
> & {
  options: GeoJSONOptionsFixed;
};

export type MapRegistryEntry = {
  map: LeafletMap;
  layerKommunen: GeoJSONFixed;
  layerLandkreise: GeoJSONFixed;
  activeLandkreis?: GeoJSONFixed;
  activeKommune?: GeoJSONFixed;
  hoveredLayer?: GeoJSONFixed;
  infoItem?: { update: (regschl: string) => void };
  regschlToLayer: Map<string, GeoJSONFixed>;
  renderedRegschl?: string;
};

export const mapRegistry = {
  entries: new Map<string, MapRegistryEntry>(),
};

let instanceCounter = 0;
export function getNextInstanceNumber() {
  return instanceCounter++;
}
